export default __webpack_public_path__ + "static/media/avt-logo-with-name.6211e9eb.svg";